export const strings = {
  SMM_space_title: 'IQVIA SMM Alanı',
  show_more_comments: 'Daha fazla yorum göster',
  open_app: 'Uygulamada Aç',
  load_more: 'Daha fazla yükle',
  other: 'Diğer',
  show_more: '…. daha ',
  show_less: 'Daha az',
  invite_members: 'Yeni Davet Et',
  invite: 'Davet etmek',
  invite_new_members: 'Yeni Üye(ler) Davet Et',
  search_people: 'Üye Ara',
  copy_link: 'Bağlantıyı kopyala',
  share_link: 'Linki paylaş',
  share_invitation_link: 'Davet bağlantısını paylaşın',
  share_profile: 'Profili Paylaş',
  share_profilee: 'Paylaş',
  close: 'İptal',
  to: 'dan',
  recent: 'Yeni',
  view_previous_reply: 'Önceki yanıtı görüntüle',
  name: 'Ad',
  message: 'İleti',
  mutual_connections: 'Karşılıklı Bağlantılar',
  received: 'Alınan',
  sent: 'Gönderilen',
  sort_by: 'Sıralama ölçütü',
  registered: 'Kaydedildi',
  connecting: 'Bağlanma',
  register: 'Kaydolmak',
  join: 'Katılmak',
  play: 'Oynat',
  ended: 'Sona erdi',
  members: 'Üyeler',
  posted_at: 'Yayınlanan',
  see_all: 'Tümünü Gör',
  people: 'İnsanlar ',
  jobs: 'İşler',
  webinars: 'Webinarlar',
  events: 'Olaylar',
  groups: 'Gruplar',
  cases: 'Vakalar',
  articles: 'Makaleler',
  showing_counts: '{count} sayıları gösteriliyor',
  showing_results: '{result} sonuçları gösteriliyor',
  showing_result: '{result} sonucu gösteriliyor',
  published_at: 'Yayınlandı',
  processing: 'İşleniyor',
  cover: 'Örtmek',
  edit_details: 'Basit detayları düzenleyin',
  edit: 'Düzenlemek',
  cover_image: 'Kapak Resmi',
  avatar_image: 'Avatar Resmi',
  logo_image: 'Logo Görseli',
  zoom: 'Yakınlaştırmak',
  straighten: 'Düzeltmek',
  change_image: 'Resmi Değiştir',
  save: 'Kaydet',
  drag_to_reposition: 'Görüntüyü yeniden konumlandırmak için sürükleyin',
  share_article: '{name} paylaşımını paylaşın',
  remove_connection: 'Bağlantıyı Kaldır',
  add_tags: 'Etiket Ekle',
  new: 'Yeni',
  mentions: 'Bahsetmeler',
  add_mention: 'Bahsetme Ekle',
  search_groups: 'Arama grupları',
  search_people_conn: 'Kişi Ara',
  all_specialities: 'Tüm Uzmanlık Alanları',
  all_countires: 'Tüm Ülkeler',
  no_cases: 'Vaka yok',
  no_articles: 'Makale Yok',
  no_searchdata: 'Sonuç bulunamadı',
  no_searchData_msg: 'için herhangi bir sonuç bulamadık',
  select_webinar: 'Tüm Web Seminerini Seç',
  select_any_webinar: 'Herhangi bir Web Semineri seçin',
  select_any_group: 'Herhangi bir Grubu seçin',
  select_group: 'Tüm Grubu Seç',
  share: 'Paylaş',
  sponsored: 'Sponsor',
  fname: 'Ad',
  lname: 'Soyadı',
  recommended: 'Önerilen',
  latest: 'Sonuncu',
  popular: 'Popüler',
  days: 'Son 7 Gün',
  last_a_month: 'Son 1 Ay',
  last_three_months: 'Son 3 Ay',
  open: 'Açık',
  view: 'Görüntülemeler',
  create: 'Oluştur',
  update: 'Güncelle',
  // edit: 'Düzenleme Formu',
  remove: 'Kaldır',
  manage: 'Yönet',
  delete: 'Sil',
  cancel: 'İptal',
  no_content: 'Burada içerik yok.',
  most_comments: 'En Çok Yorum',
  most_recent: 'En Son',
  attachments: 'Ekler  ',
  upload_attachments: 'Ekleri Karşıya Yükle',
  web_links: 'Web bağlantıları',
  view_previous_replies: 'Önceki yanıtları görüntüleme',
  view_more_comments: 'Daha fazla yorum görüntüle',
  dropzone_title: 'Bilgisayarınızdan bir veya daha fazla dosya seçin',
  dropzone_subtitle:
    'veya dosyaları yüklemek için dosyaları buraya sürükleyip bırakın',
  dropzone_subtitle_help: '(Yalnızca MP4, PDF, JPEG, JPG desteklenir)',
  dropzone_disclaimer:
    'Lütfen hasta gizliliğinin ihlal edilmediğinden emin olun.',
  footer_text:
    'CAVi (Kardiyak Amiloidoz Sanal Kliniği), Pfizer tarafından desteklenen ve IQVIA tarafından geliştirilen bir uzmanlık tartışma platformudur ("Platform"), doğrulanmış Platform kullanıcılarının ve diğer üçüncü tarafların materyallerinin gerçekleri, görüşleri, bağımsız görüşleri, ifadeleri ve önerilerini içerir. Platform aracılığıyla sunulan bilgi ve materyallerin yalnızca bilgilendirme amaçlı olduğunu ve profesyonel tavsiye, teşhis veya tedavi oluşturmayı amaçlamadığını anlıyorsunuz. Platform aracılığıyla görüntülenen, yüklenen veya dağıtılan herhangi bir bilgi veya materyalin doğruluğunu, eksiksizliğini veya güvenilirliğini temsil etmiyoruz veya onaylamıyoruz. Platformdan veya Platform aracılığıyla elde ettiğiniz bilgi ve materyallerin kullanımından doğan tüm risk ve sorumluluğu üstlenirsiniz.',
  signin_disclaimer:
    'CAVi, yalnızca belirli ülkelerde ikamet eden lisanslı sağlık profesyonellerinin kullanımına ve yararına yönelik olarak tasarlanmıştır',
  continue: 'Devam etmek',
  start_typing_for_suggestions: 'Öneri için yazmaya başla',
  endorse: 'Onaylandı',
  endorsed: 'Onaylandı',
  read_less: 'Daha az oku',
  read_more: 'Devamını oku...',
  bytes: 'bayt',
  file_invalid_type:
    'Dosya türü şu formatlardan biri olmalıdır image/jpeg, image/jpg, video/mp4, application/pdf, image/png',
};
